import { jsx as _jsx } from "react/jsx-runtime";
import { withBaseIcon } from '../src/Icons.utils';
export const CheckCircleLine = (props) => withBaseIcon(_jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", role: "img", children: _jsx("path", { d: "M8.5 12.5L11 15L16.5 9.5M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) }), props);
CheckCircleLine.iconName = 'check-circle';
CheckCircleLine.displayName = 'CheckCircleLine';
export default CheckCircleLine;
